$(document).ready(function () {
  setTimeout(function () {
    $(".shopify-payment-button__more-options").text("buy it now");
  }, 600),
    setTimeout(function () {
      $(".shopify-payment-button__more-options").text("buy it now");
    }, 700),
    setTimeout(function () {
      $(".shopify-payment-button__more-options").text("buy it now");
    }, 800),
    setTimeout(function () {
      $(".shopify-payment-button__more-options").text("buy it now");
    }, 900),
    setTimeout(function () {
      $(".shopify-payment-button__more-options").text("buy it now");
    }, 1000),
    setTimeout(function () {
      $(".shopify-payment-button__more-options").text("buy it now");
    }, 1100),
    setTimeout(function () {
      $(".shopify-payment-button__more-options").text("buy it now");
    }, 1200),
    setTimeout(function () {
      $(".shopify-payment-button__more-options").text("buy it now");
    }, 1300),
    setTimeout(function () {
      $(".shopify-payment-button__more-options").text("buy it now");
    }, 1400),
    setTimeout(function () {
      $(".shopify-payment-button__more-options").text("buy it now");
    }, 1500),
    setTimeout(function () {
      $(".shopify-payment-button__more-options").text("buy it now");
    }, 1700),
    setTimeout(function () {
      $(".shopify-payment-button__more-options").text("buy it now");
    }, 1900),
    setTimeout(function () {
      $(".shopify-payment-button__more-options").text("buy it now");
    }, 2100),
    setTimeout(function () {
      $(".shopify-payment-button__more-options").text("buy it now");
    }, 2300),
    setTimeout(function () {
      $(".shopify-payment-button__more-options").text("buy it now");
    }, 2500),
    setTimeout(function () {
      $(".shopify-payment-button__more-options").text("buy it now");
    }, 4500),
    // Change Buy It Now

    $("#AddToCart").click(function () {
      setTimeout(function () {
        $(".shopify-payment-button__more-options").text("buy it now");
      }, 250);
      setTimeout(function () {
        $(".shopify-payment-button__more-options").text("buy it now");
      }, 300);
      setTimeout(function () {
        $(".shopify-payment-button__more-options").text("buy it now");
      }, 400);
      setTimeout(function () {
        $(".shopify-payment-button__more-options").text("buy it now");
      }, 500);
      setTimeout(function () {
        $(".shopify-payment-button__more-options").text("buy it now");
      }, 600);
      setTimeout(function () {
        $(".shopify-payment-button__more-options").text("buy it now");
      }, 700);
      setTimeout(function () {
        $(".shopify-payment-button__more-options").text("buy it now");
      }, 800);
      setTimeout(function () {
        $(".shopify-payment-button__more-options").text("buy it now");
      }, 900);
      setTimeout(function () {
        $(".shopify-payment-button__more-options").text("buy it now");
      }, 1000);
      setTimeout(function () {
        $(".shopify-payment-button__more-options").text("buy it now");
      }, 1200);
      setTimeout(function () {
        $(".shopify-payment-button__more-options").text("buy it now");
      }, 1400);
      setTimeout(function () {
        $(".shopify-payment-button__more-options").text("buy it now");
      }, 1600);
      setTimeout(function () {
        $(".shopify-payment-button__more-options").text("buy it now");
      }, 1800);
      setTimeout(function () {
        $(".shopify-payment-button__more-options").text("buy it now");
      }, 2000);
      setTimeout(function () {
        $(".shopify-payment-button__more-options").text("buy it now");
      }, 2200);
      setTimeout(function () {
        $(".shopify-payment-button__more-options").text("buy it now");
      }, 3000);
      setTimeout(function () {
        $(".shopify-payment-button__more-options").text("buy it now");
        $(".esc-email-input").attr("value", "email@email.com");
      }, 5000); // not working
    });
});
